import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import PageCaption from '@/components/PageCaption.vue';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue';
import InstitutionalIdentificationSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionEdit.vue';
import InstitutionalFormatSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalFormatSectionEdit.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import { ref, computed } from 'vue';
import { useInstitutionalStore } from '@/stores/institutionalStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageInstitutionalNew',
  setup(__props) {

const institutionalStore = useInstitutionalStore()

const institutionalNewData = computed(() => {
  if (!institutionalStore.veioDaReview) return null

  const imagens = institutionalStore.imagensDraft || []

  const mapTempo = (posicao: number) => {
    const img = imagens.find(i => i.posicaoImagem === posicao)
    return img?.duracaoImagem || 10
  }

  return {
    id: 'NEW',
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, tempo: mapTempo(1) },
        { id: 2, tela: 'Tela 2', posicao: 2, tempo: mapTempo(2) },
        { id: 3, tela: 'Tela 3', posicao: 3, tempo: mapTempo(3) },
        { id: 4, tela: 'Tela 4', posicao: 4, tempo: mapTempo(4) }
      ],
      telasAtm: [
        { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
        { id: 9, botao: 'Recarga celular', posicao: 9 },
        { id: 10, botao: 'Mais serviços', posicao: 10 },
        { id: 11, botao: 'Depositar dinheiro', posicao: 11 }
      ],
      telasAguardeGeral: [{ id: 6, tela: 'Tela Geral', posicao: 6 }],
      telasAguardeChip: [{ id: 7, tela: 'Tela Chip', posicao: 7 }],
      telasAbertura: [{ id: 5, tela: 'Tela Abertura', posicao: 5 }],

      imagens,
      corTexto: institutionalStore.reviewData?.corTexto ?? null,
      exibeTelaAbertura: institutionalStore.exibeTelaAberturaRascunho
    }
  }
})


// ✅ Ref para acessar o accordion
const accordionRef = ref();

return (_ctx: any,_cache: any) => {
  const _component_c_q_separator = _resolveComponent("c-q-separator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_c_q_separator, {
      class: "q-pb-lg",
      withBackButton: true
    }),
    _createVNode(PageCaption, {
      pageCaptionTitle: "Novo Cadastro de Telas Institucionais",
      pageCaptionDescription: "Envie um novo Cadastro de Telas Institucionais para Aprovação"
    }),
    _createVNode(InstitutionalIdentificationSectionEdit),
    _createVNode(InstitutionalFormatSectionEdit),
    _createVNode(_component_c_q_separator, { class: "q-pt-lg q-pb-lg" }),
    _createVNode(InstitutionalAccordion, {
      ref_key: "accordionRef",
      ref: accordionRef,
      mode: "edit",
      accordionsData: institutionalNewData.value?.accordions
    }, null, 8, ["accordionsData"]),
    _createVNode(_component_c_q_separator, { class: "q-pt-lg q-pb-lg" }),
    _createVNode(InstitutionalActionButtonsSection, {
      propShowBtnCancelCreateNewCampaign: true,
      propShowBtnReviewFocusedCampaign: true,
      accordionRef: accordionRef.value
    }, null, 8, ["accordionRef"])
  ]))
}
}

})